import React from "react";
import FormGroupCustom from "./FormGroupCustom";
import IconBtn from "../icon/IconBtn";
import colorUtils from "../../colorUtils";
import {divisor} from "../../utils/forms/useStructureForm";


export const FormSingleElementArray = ({
                                           errors,
                                           pre,
                                           structure,
                                           dataForm = [],
                                           isSubmit,
                                           num,
                                           removeItemHandler,
                                           changeValueHandler,
                                           rightTemplate,
                                           titleTemplate,
                                           style
                                       }: {
    errors?: any;
    pre: string;
    structure: any;
    num: number;
    removeItemHandler: (num: number) => void,
    changeValueHandler: (data: any, num: number) => void,
    dataForm: any[];
    isSubmit?: boolean;
    rightTemplate?: any;
    titleTemplate?: any;
    style?: any;
}) => {

    return (
        <div className={"row align-items-start"} style={style}>
            <div className={"col-auto p-0 d-flex pt-1"}>
                <IconBtn variant={'outline-danger'} icon={'/assets/icons/trash.svg'} size={'20px'}
                         clickHandler={() => removeItemHandler(num)}
                         tintColor={colorUtils.theme.error}></IconBtn>
            </div>
            {titleTemplate}

            <div className={'col w-100'}>
                <div className={"form-array-item row"}>
                    {structure.map((ele: any, k: number) => (
                        <FormGroupCustom
                            key={k}
                            structure={{...ele, name: `${pre}${divisor}${num}${divisor}${ele.name}`}}
                            isSubmit={isSubmit}
                            dataForm={dataForm}
                            changeValue={(data: any) => changeValueHandler(data, num)}
                            errors={errors}
                        />
                    ))}
                </div>
            </div>
            {rightTemplate && rightTemplate}
        </div>
    );
};
